import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Field } from '~/components';
import { useApi, useWorkspace } from '~/contexts';

const TotalToBillPreview = ({ currency, project, expenseAmount, date }) => {
  const { workspace } = useWorkspace();
  const api = useApi();

  const [amount, setAmount] = useState(null);

  useEffect(() => {
    if (!currency || !date || !project) return;

    if (!expenseAmount) return setAmount(null);
    if (currency === project.currency) return setAmount(expenseAmount);

    const debounced = _.debounce(async () => {
      const response = await api.www.workspaces(workspace.id).exchangeRates.convert({
        amount: expenseAmount,
        date,
        from: currency,
        to: project.currency,
      });

      setAmount(response.data);
    }, 300);

    debounced();

    return () => {
      debounced.cancel();
    };
  }, [currency, project, expenseAmount, date, api, workspace]);

  return (
    <Field.Currency
      name="total"
      value={amount}
      disabled
      materialAlwaysVisible
      currency={project ? project.currency : workspace.currency}
    />
  );
};

export default TotalToBillPreview;
